import { ScrollTrigger } from "gsap/all";

export default class PageProgress {
    constructor() {
        this.progressIndicator = document.querySelector('[data-page-progress]');

        if (!this.progressIndicator) {
            return;
        }

        this.container = document.querySelector('main');
        this.progressBar = this.progressIndicator.querySelector('[data-page-progress-bar]');

        ScrollTrigger.create({
            trigger: this.container,
            start: 'top top',
            end: 'bottom bottom',
            onUpdate: (self) => {
                let progress = `${self.progress * 100}%`;
                this.progressBar.style.setProperty('--progress', progress);
            },
        });
    }
}